import { AssociatedRecords } from './AssociatedRecords';
import { EnrichmentPropertiesFooter } from './EnrichmentPropertiesFooter';
import { EnrichmentPropertiesProvider } from './EnrichmentPropertiesProvider';
import { EnrichmentPropertiesContextProvider } from './useEnrichmentProperties/EnrichmentPropertiesContextProvider';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { EnrichmentPropertiesBody } from './EnrichmentPropertiesBody';
import { BasePanel } from '../Panel/BasePanel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnrichmentProperties(props) {
  return /*#__PURE__*/_jsx(EnrichmentPropertiesProvider, {
    children: /*#__PURE__*/_jsx(EnrichmentPropertiesInternal, Object.assign({}, props))
  });
}
export function EnrichmentPropertiesInternal({
  objectId,
  objectTypeId,
  onClose
}) {
  const sendCloseEnrichPanelMessage = useSendCrmMessageTopic('CLOSE_ENRICHMENT_PROPERTIES_PANEL');
  function handleClose(enriched) {
    sendCloseEnrichPanelMessage({
      objectId,
      objectTypeId: objectTypeId,
      enriched
    });
    onClose === null || onClose === void 0 || onClose();
  }
  return /*#__PURE__*/_jsx(EnrichmentPropertiesContextProvider, {
    objectId: objectId,
    objectTypeId: objectTypeId,
    onClose: handleClose,
    children: /*#__PURE__*/_jsxs(BasePanel, {
      inlineSize: "1000px",
      isOpen: true,
      onClose: () => handleClose(false),
      children: [/*#__PURE__*/_jsx(BasePanel.Header, {
        children: /*#__PURE__*/_jsx(BasePanel.Heading, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.panel.title"
          })
        })
      }), /*#__PURE__*/_jsx(EnrichmentPropertiesBody, {}), /*#__PURE__*/_jsx(AssociatedRecords, {}), /*#__PURE__*/_jsx(EnrichmentPropertiesFooter, {})]
    })
  });
}